webpackJsonp([1],{

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NoteList__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NoteList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_NoteList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Note__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CreateNote__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CreateNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CreateNote__);


// import VueLocalStorage from 'vue-localstorage';





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
// Vue.use(VueLocalStorage);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'All Notes',
    component: __WEBPACK_IMPORTED_MODULE_2__components_NoteList___default.a
  }, {
    path: '/view/:id',
    name: 'View Note',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Note___default.a,
    props: true
  }, {
    path: '/edit/:id',
    name: 'Edit Note',
    component: __WEBPACK_IMPORTED_MODULE_4__components_CreateNote___default.a,
    props: true
  }, {
    path: '/new',
    name: 'Create Note',
    component: __WEBPACK_IMPORTED_MODULE_4__components_CreateNote___default.a
  }]
}));

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(224),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var uuidV4 = __webpack_require__(217);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      note: {}
      // noteIndex: -1,
    };
  },
  mounted: function mounted() {
    if (undefined !== this.id) {
      this.loadNote();
    }
  },

  methods: {
    loadNote: function loadNote() {
      var _this = this;

      var getLocalNotes = localStorage.getItem('vuejs-note');
      var notes = JSON.parse(getLocalNotes);

      if (undefined !== this.id) {
        this.note = notes.find(function (note) {
          return note.id === _this.id;
        });
      } else {
        this.$router.push('/');
      }
    },
    saveNote: function saveNote() {
      var _this2 = this;

      var getLocalNotes = localStorage.getItem('vuejs-note');
      var notes = null === getLocalNotes ? [] : JSON.parse(getLocalNotes);

      var title = document.querySelector('.title');
      var createTextarea = document.querySelector('textarea');

      var editedNote = {
        title: this.note.title,
        id: this.note.id || uuidV4(),
        meta: Date.now(),
        tag: this.note.tag,
        text: this.note.text
      };

      var meetIndex = notes.findIndex(function (note) {
        return note.id === _this2.id;
      });

      if (title.value.trim() == '') {
        return this.$router.push('/');
      } else if (undefined !== meetIndex && meetIndex >= 0) {
        notes[meetIndex] = editedNote;
      } else {
        notes.push(editedNote);
      }

      localStorage.setItem('vuejs-note', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notes));
      this.$router.push('/');
    },
    goBack: function goBack() {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      note: {}
    };
  },
  mounted: function mounted() {
    this.loadNote();
  },

  methods: {
    loadNote: function loadNote() {
      var _this = this;

      var getLocalNotes = localStorage.getItem('vuejs-note');
      // const notes = JSON.parse(getLocalNotes);
      var notes = null === getLocalNotes ? [] : JSON.parse(getLocalNotes);
      this.note = notes.find(function (note) {
        return note.id === _this.id;
      });

      if (!this.note) {
        this.$router.push('/');
      }
    },
    parseTimeCreate: function parseTimeCreate(time) {
      return moment(time).format('LLL');
    },
    goBack: function goBack() {
      this.$router.push('/');
    },
    editNote: function editNote() {
      if (this.note) {
        this.$router.push({ name: 'Edit Note', params: { id: this.note.id } });
      }
    },
    deleteNote: function deleteNote() {
      var _this2 = this;

      var getLocalNotes = localStorage.getItem('vuejs-note');
      var notes = null === getLocalNotes ? [] : JSON.parse(getLocalNotes);
      var meetIndex = notes.findIndex(function (note) {
        return note.id === _this2.id;
      });

      if (confirm('Delete note?')) {
        notes.splice(meetIndex, 1);
        localStorage.setItem('vuejs-note', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notes));
        this.$router.push('/');
      }
    }
  }
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NoteListItems__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NoteListItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NoteListItems__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { NoteListItems: __WEBPACK_IMPORTED_MODULE_1__components_NoteListItems___default.a },
  data: function data() {
    return {
      notes: [],
      searchWord: '',
      tags: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a().add('all tags'),
      tag: 'all tags'
    };
  },
  mounted: function mounted() {
    this.loadNotes();
  },

  computed: {
    notesFiltered: function notesFiltered() {
      var searchWord = this.searchWord.trim().toLowerCase();
      var headings = ['title', 'text', 'tag'];
      var tag = this.tag;

      return this.notes.filter(function (note) {
        // console.log(note['title']);
        if (note['title'] !== '') {
          var LowerSearch = function LowerSearch(obj) {
            return obj.toLowerCase().indexOf(searchWord) !== -1;
          };

          note['text'] = undefined === note['text'] ? '' : note['text'];
          note['tag'] = undefined === note['tag'] ? '' : note['tag'];

          ;

          return searchWord === "" || LowerSearch(note['title']) || LowerSearch(note['text']) || LowerSearch(note['tag']);
        }
      }).filter(function (note) {
        if (tag == 'all tags') return note;
        if (tag !== 'all tags') {
          return note['tag'].indexOf(tag) !== -1;
        }
      });
    }
  },
  methods: {
    loadNotes: function loadNotes() {
      var _this = this;

      var testData = [{
        title: 'note 1',
        meta: 1502445791235,
        tag: "work",
        text: "the first record...Strange first one"
      }, {
        title: 'note 2',
        meta: 1502445791235,
        tag: "work",
        text: "the 2 record"
      }, {
        title: 'note 3',
        meta: 1502445791235,
        tag: "work",
        text: "the 3 record"
      }];
      // localStorage.setItem('vuejs-note', JSON.stringify(testData));
      var getLocalNotes = localStorage.getItem('vuejs-note');
      this.notes = null === getLocalNotes ? [] : JSON.parse(getLocalNotes);
      // console.log(this.notes);

      this.notes.forEach(function (note) {
        if (note['tag'] !== '') {
          return _this.tags.add(note['tag']);
        }
      });
    },
    createNote: function createNote() {
      this.$router.push('new');
    }
  }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['note'],
  methods: {
    parseTimeCreate: function parseTimeCreate(time) {
      return moment(time).format('LLL');
    },
    subStringTitle: function subStringTitle(words) {
      if (words.length > 40) {
        return words.substring(0, 40) + "...";
      } else {
        return words;
      }
    }
  }
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 42,
	"./af.js": 42,
	"./ar": 49,
	"./ar-dz": 43,
	"./ar-dz.js": 43,
	"./ar-kw": 44,
	"./ar-kw.js": 44,
	"./ar-ly": 45,
	"./ar-ly.js": 45,
	"./ar-ma": 46,
	"./ar-ma.js": 46,
	"./ar-sa": 47,
	"./ar-sa.js": 47,
	"./ar-tn": 48,
	"./ar-tn.js": 48,
	"./ar.js": 49,
	"./az": 50,
	"./az.js": 50,
	"./be": 51,
	"./be.js": 51,
	"./bg": 52,
	"./bg.js": 52,
	"./bn": 53,
	"./bn.js": 53,
	"./bo": 54,
	"./bo.js": 54,
	"./br": 55,
	"./br.js": 55,
	"./bs": 56,
	"./bs.js": 56,
	"./ca": 57,
	"./ca.js": 57,
	"./cs": 58,
	"./cs.js": 58,
	"./cv": 59,
	"./cv.js": 59,
	"./cy": 60,
	"./cy.js": 60,
	"./da": 61,
	"./da.js": 61,
	"./de": 64,
	"./de-at": 62,
	"./de-at.js": 62,
	"./de-ch": 63,
	"./de-ch.js": 63,
	"./de.js": 64,
	"./dv": 65,
	"./dv.js": 65,
	"./el": 66,
	"./el.js": 66,
	"./en-au": 67,
	"./en-au.js": 67,
	"./en-ca": 68,
	"./en-ca.js": 68,
	"./en-gb": 69,
	"./en-gb.js": 69,
	"./en-ie": 70,
	"./en-ie.js": 70,
	"./en-nz": 71,
	"./en-nz.js": 71,
	"./eo": 72,
	"./eo.js": 72,
	"./es": 74,
	"./es-do": 73,
	"./es-do.js": 73,
	"./es.js": 74,
	"./et": 75,
	"./et.js": 75,
	"./eu": 76,
	"./eu.js": 76,
	"./fa": 77,
	"./fa.js": 77,
	"./fi": 78,
	"./fi.js": 78,
	"./fo": 79,
	"./fo.js": 79,
	"./fr": 82,
	"./fr-ca": 80,
	"./fr-ca.js": 80,
	"./fr-ch": 81,
	"./fr-ch.js": 81,
	"./fr.js": 82,
	"./fy": 83,
	"./fy.js": 83,
	"./gd": 84,
	"./gd.js": 84,
	"./gl": 85,
	"./gl.js": 85,
	"./gom-latn": 86,
	"./gom-latn.js": 86,
	"./he": 87,
	"./he.js": 87,
	"./hi": 88,
	"./hi.js": 88,
	"./hr": 89,
	"./hr.js": 89,
	"./hu": 90,
	"./hu.js": 90,
	"./hy-am": 91,
	"./hy-am.js": 91,
	"./id": 92,
	"./id.js": 92,
	"./is": 93,
	"./is.js": 93,
	"./it": 94,
	"./it.js": 94,
	"./ja": 95,
	"./ja.js": 95,
	"./jv": 96,
	"./jv.js": 96,
	"./ka": 97,
	"./ka.js": 97,
	"./kk": 98,
	"./kk.js": 98,
	"./km": 99,
	"./km.js": 99,
	"./kn": 100,
	"./kn.js": 100,
	"./ko": 101,
	"./ko.js": 101,
	"./ky": 102,
	"./ky.js": 102,
	"./lb": 103,
	"./lb.js": 103,
	"./lo": 104,
	"./lo.js": 104,
	"./lt": 105,
	"./lt.js": 105,
	"./lv": 106,
	"./lv.js": 106,
	"./me": 107,
	"./me.js": 107,
	"./mi": 108,
	"./mi.js": 108,
	"./mk": 109,
	"./mk.js": 109,
	"./ml": 110,
	"./ml.js": 110,
	"./mr": 111,
	"./mr.js": 111,
	"./ms": 113,
	"./ms-my": 112,
	"./ms-my.js": 112,
	"./ms.js": 113,
	"./my": 114,
	"./my.js": 114,
	"./nb": 115,
	"./nb.js": 115,
	"./ne": 116,
	"./ne.js": 116,
	"./nl": 118,
	"./nl-be": 117,
	"./nl-be.js": 117,
	"./nl.js": 118,
	"./nn": 119,
	"./nn.js": 119,
	"./pa-in": 120,
	"./pa-in.js": 120,
	"./pl": 121,
	"./pl.js": 121,
	"./pt": 123,
	"./pt-br": 122,
	"./pt-br.js": 122,
	"./pt.js": 123,
	"./ro": 124,
	"./ro.js": 124,
	"./ru": 125,
	"./ru.js": 125,
	"./sd": 126,
	"./sd.js": 126,
	"./se": 127,
	"./se.js": 127,
	"./si": 128,
	"./si.js": 128,
	"./sk": 129,
	"./sk.js": 129,
	"./sl": 130,
	"./sl.js": 130,
	"./sq": 131,
	"./sq.js": 131,
	"./sr": 133,
	"./sr-cyrl": 132,
	"./sr-cyrl.js": 132,
	"./sr.js": 133,
	"./ss": 134,
	"./ss.js": 134,
	"./sv": 135,
	"./sv.js": 135,
	"./sw": 136,
	"./sw.js": 136,
	"./ta": 137,
	"./ta.js": 137,
	"./te": 138,
	"./te.js": 138,
	"./tet": 139,
	"./tet.js": 139,
	"./th": 140,
	"./th.js": 140,
	"./tl-ph": 141,
	"./tl-ph.js": 141,
	"./tlh": 142,
	"./tlh.js": 142,
	"./tr": 143,
	"./tr.js": 143,
	"./tzl": 144,
	"./tzl.js": 144,
	"./tzm": 146,
	"./tzm-latn": 145,
	"./tzm-latn.js": 145,
	"./tzm.js": 146,
	"./uk": 147,
	"./uk.js": 147,
	"./ur": 148,
	"./ur.js": 148,
	"./uz": 150,
	"./uz-latn": 149,
	"./uz-latn.js": 149,
	"./uz.js": 150,
	"./vi": 151,
	"./vi.js": 151,
	"./x-pseudo": 152,
	"./x-pseudo.js": 152,
	"./yo": 153,
	"./yo.js": 153,
	"./zh-cn": 154,
	"./zh-cn.js": 154,
	"./zh-hk": 155,
	"./zh-hk.js": 155,
	"./zh-tw": 156,
	"./zh-tw.js": 156
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e93f6c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bb03f04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(222),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 222:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NoteList"
  }, [_c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "searchBar"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "search the notes"
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tag),
      expression: "tag"
    }],
    staticClass: "tagSelect",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tag = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((Array.from(_vm.tags)), function(tag) {
    return _c('option', [_vm._v(_vm._s(tag))])
  })), _c('button', {
    staticClass: "addNote",
    on: {
      "click": _vm.createNote
    }
  }, [_vm._v("Add Note")])])]), _c('div', {
    staticClass: "items"
  }, [_c('ul', _vm._l((_vm.notesFiltered), function(note, index) {
    return _c('li', [_c('NoteListItems', {
      attrs: {
        "note": note
      }
    })], 1)
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NoteListItems"
  }, [_c('div', {
    staticClass: "noteContainer"
  }, [_c('div', {
    staticClass: "topper"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'View Note',
        params: {
          id: _vm.note.id
        }
      }
    }
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.subStringTitle(_vm.note.title)))])])], 1)]), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.parseTimeCreate(_vm.note.meta)))]), _c('div', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.note.tag))])])])
},staticRenderFns: []}

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Note"
  }, [_c('header', [_c('a', {
    staticClass: "backToList"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _c('span', {
    staticClass: "menuText"
  }, [_vm._v("Viewing Note")])]), _c('a', {
    on: {
      "click": function($event) {
        _vm.editNote()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _c('a', {
    on: {
      "click": function($event) {
        _vm.deleteNote()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.note.title))]), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.parseTimeCreate(_vm.note.meta)))]), _c('div', {
    staticClass: "tag"
  }, [_vm._v(" " + _vm._s(_vm.note.tag))]), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.note.text))])])])
},staticRenderFns: []}

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CreateNote"
  }, [_c('header', [_c('a', {
    staticClass: "backToList"
  }, [_c('span', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _c('span', {
    staticClass: "menuText"
  }, [_vm._v(_vm._s(undefined !== this.id ? 'Editing Note' : 'Create Note'))])]), _c('a', {
    on: {
      "click": _vm.saveNote
    }
  }, [_c('button', {
    staticClass: "saveNote"
  }, [_vm._v("Save")])])]), _c('div', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.title),
      expression: "note.title"
    }],
    staticClass: "title",
    attrs: {
      "placeholder": "Note title is required"
    },
    domProps: {
      "value": (_vm.note.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.title = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.tag),
      expression: "note.tag"
    }],
    staticClass: "tag",
    attrs: {
      "placeholder": "Note tag"
    },
    domProps: {
      "value": (_vm.note.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.tag = $event.target.value
      }
    }
  }), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.text),
      expression: "note.text"
    }],
    attrs: {
      "placeholder": "Note..."
    },
    domProps: {
      "value": (_vm.note.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.text = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}

/***/ })

},[168]);


// WEBPACK FOOTER //
// static/js/app.d2d0ec45376e1b851b72.js